import { useMemo } from "react";
import SimpleTableTemplate from "@/components/Templates/SimpleTableTemplate";
import breaches from "@/assets/data/json_output/breaches-issues.json";
import {
  useOpenRecordFromParam,
  useSelectableTableView,
} from "@/utils/tableHelpers";
import { createBreachColumns } from "@/views/Risk/Breaches/breachesTableConfig";
import BreachesDrawer from "@/views/Risk/Breaches/BreachesDrawer";
import type { BreachTableRow } from "@/views/Risk/Breaches/utils";

const breachRows = breaches as BreachTableRow[];

export default function Breaches() {
  const { selectedRecord, setSelectedRecord, getClickableRowProps } =
    useSelectableTableView<BreachTableRow>();
  const columns = useMemo(() => createBreachColumns(breachRows), []);

  useOpenRecordFromParam({
    paramName: "openIssue",
    rows: breachRows,
    idField: "breach_id",
    setSelectedRecord,
  });

  return (
    <div className="flex w-full min-w-0 flex-col p-4">
      <SimpleTableTemplate
        title="Breaches"
        tooltipText="Review breach events triggered by signals, including severity, status, breached thresholds, and assigned ownership."
        fileName="breaches-issues"
        data={breachRows}
        columns={columns}
        rowKey="breach_id"
        onRow={getClickableRowProps}
      />
      <BreachesDrawer
        selectedRecord={selectedRecord}
        setSelectedRecord={setSelectedRecord}
      />
    </div>
  );
}
